// extracted by mini-css-extract-plugin
export default {"text":"Text_text__wWusZ","weightBold":"Text_weightBold__4M-6a","link":"Text_link__ktMpo"};